import { plot, barY, gridY, ruleY } from "@observablehq/plot";
import { formatLocale, select } from "d3";

const black = '#262626'
const { format } = formatLocale({
    decimal: '.',
    thousands: ",",
    grouping: [3],
    currency: ["£", ""]
});

const data = [
    { year: new Date('2021'), total: 27453 },
    { year: new Date('2022'), total: 34513 },
    { year: new Date('2023'), total: 62025 },
    { year: new Date('2024'), total: 88605 },
    { year: new Date('2025'), total: 107003 },
]

const scale = 2.4


export const donations = plot({
    title: "Donations received by year",
    marginLeft: 80,
    marginBottom: 40,
    width: 160 * scale,
    height: 100 * scale,
    y: { tickFormat: format("$.0s"), tickSize: 0, tickPadding: 5, label: 'Amount', labelAnchor: 'center', labelArrow: null, paddingOuter: 2 },
    x: { interval: "year", label: 'Year', labelArrow: null, tickSize: 0, stroke: '  black' },
    marks: [
        gridY({ strokeOpacity: 1, stroke: black, strokeDasharray: '1,2', strokeWidth: 1 }),
        ruleY([0], { stroke: black }),
        barY(data, { x: "year", y: "total", stroke: black, fill: 'white', rx1y1: 3, rx2y1: 3, tip: { stroke: black, format: { y: format("$,"), x: false } } }),
    ]
})

